// Seleção de usuários da Matriz de Acessos: "Selecionar todos" age só sobre os usuários elegíveis da lista exibida
// (os bloqueados nem aparecem) e convive com a marcação individual.

export type EstadoSelecaoTodos = 'nenhum' | 'alguns' | 'todos';

export const estadoSelecaoTodos = (elegiveis: number[], selecionados: number[]): EstadoSelecaoTodos => {
  if (elegiveis.length === 0) return 'nenhum';
  const marcados = elegiveis.filter(id => selecionados.includes(id)).length;
  return marcados === 0 ? 'nenhum' : marcados === elegiveis.length ? 'todos' : 'alguns';
};

/** Se todos os elegíveis já estão marcados, desmarca todos; senão marca todos. Ids fora da lista elegível não são mexidos. */
export const alternarTodos = (elegiveis: number[], selecionados: number[]): number[] => {
  if (estadoSelecaoTodos(elegiveis, selecionados) === 'todos') return selecionados.filter(id => !elegiveis.includes(id));
  return Array.from(new Set([...selecionados, ...elegiveis]));
};

export const resumoSelecao = (elegiveis: number[], selecionados: number[]): string => {
  const n = elegiveis.filter(id => selecionados.includes(id)).length;
  return `${n} de ${elegiveis.length} usuário(s) selecionado(s)`;
};
